import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { CardModel } from '@shared/models/card.model';
import { Config } from '@core/config';

@Injectable({
  providedIn: 'root',
})
export class CardService {
  constructor(private httpClient: HttpClient) {}

  /**
   * Get a card data from API.
   * @param {string} id
   * @returns {Observable<CardModel>}
   */
  getCard(id: string): Observable<CardModel> {
    return this.httpClient.get<CardModel>(`${Config.serverUrl}fiche/${id}`, {
      responseType: 'json',
    });
  }

  getCardKml(url: string) {
    return url
      ? this.httpClient.get(url, {
          responseType: 'text',
          headers: { 'Content-Type': 'application/xml' },
        })
      : null;
  }

  /**
   * Set rating from API.
   * @param {string} id
   * @param {number} rating
   */
  setRating(id: string, rating: number): void {
    this.httpClient
      .post<any>(
        `${Config.serverUrl}fiche/${id}/vote`,
        {
          rating: rating,
          idUser: id,
        },
        { headers: { 'Content-Type': 'application/json' } }
      )
      .subscribe((e) => null);
  }

  /**
   * Set a new value to rating and get the updated votes value.
   * @param {string} id
   * @param {number} rating
   * @returns {Promise<number>} Get the updated avg rating.
   */
  async setNewRating(
    id: string,
    idUser: string,
    rating: number
  ): Promise<CardModel> {
    const urlPost = `${Config.serverUrl}fiche/${id}/vote`;
    const body = {
      rating: rating,
      idUser: idUser,
    };
    await this.httpClient
      .post(urlPost, body, {
        headers: { 'Content-Type': 'application/json' },
        responseType: 'text',
      })
      .toPromise();
    const urlGet = `${Config.serverUrl}fiche/${id}`;
    return this.httpClient
      .get<CardModel>(urlGet, { responseType: 'json' })
      .toPromise();
  }

  async getCircuitDenivele(id: string) {
    const url = `${Config.serverUrl}fiche/${id}/denivele`;
    try {
      return await this.httpClient
        .get(url, {
          headers: { 'Content-Type': 'application/json' },
          responseType: 'text',
        })
        .toPromise();
    } catch (error) {
      console.log(error);
      return null;
    }
  }
}
